import { Request } from '@/helpers'
import { ENDPOINTS } from '@/data'

const Delete = async (
    tagId: string,
    Tags: Array<TagInterface>,
    SetTags: Function,
    setDeleting: Function,
    InitNotification: Function
) => {
    setDeleting(tagId)

    try {
        const { success, message } = await Request({
            path: ENDPOINTS.DELETE_TAG,
            method: 'DELETE',
            body: { tagId }
        })

        if (success) {
            InitNotification(message)

            const tags = structuredClone(Tags)
            const index = tags?.findIndex(({ _id }) => _id === tagId)

            tags?.splice(index, 1)
            SetTags({ Tags: tags })
        }

        else InitNotification(message)
    }

    catch (error) {
        console.error(error)
        InitNotification('Something went wrong while trying to delete your tag!')
    }

    finally {
        setDeleting(false)
    }
}

export default Delete
